import request from '@/utils/request'
import URL from '@/api/urlTranslator'

export function getNotWriteoffCharges(requestBody) {
  return request({
    url: URL.act.actualAmount.getNotWriteoffChargesUrl,
    method: 'post',
    data: requestBody
  })
}

export function chargeWriteoff(requestBody) {
  return request({
    url: URL.act.actualAmount.chargeWriteoffUrl,
    method: 'post',
    data: requestBody
  })
}
export function pushWriteOffSap(requestBody) {
  return request({
    url: URL.act.actualAmount.pushWriteOffSapUrl,
    method: 'post',
    data: requestBody
  })
}

export function saveActualAmount(data) {
  return request({
    url: URL.act.actualAmount.saveActualAmount,
    method: 'post',
    data
  })
}
// 海外结算中心，结款通知查询
export function queryActualAmount(data) {
  return request({
    url: URL.act.actualAmount.queryActualAmount,
    method: 'post',
    data
  })
}
// 新版海外结算中心，结款通知查询
export function queryActualAmountAdv(data) {
  return request({
    url: URL.act.actualAmount.queryActualAmountAdv,
    method: 'post',
    data
  })
}

// 海外结算中心，结款通知查询
export function sendHQOfficeEmail(data) {
  return request({
    url: URL.act.actualAmount.sendHQOfficeEmail,
    method: 'post',
    data
  })
}
// 海外结算中心，预览内容
export function preViewOfficeHtml(data) {
  return request({
    url: URL.act.actualAmount.preViewOfficeHtml,
    method: 'post',
    data
  })
}
// 海外结算中心，发送分公司
export function sendOfficeConfirm(data, params) {
  return request({
    url: URL.act.actualAmount.sendOfficeConfirm,
    method: 'post',
    data: data,
    params: params
  })
}

export function getClearHistory(params) {
  return request({
    url: URL.act.actualAmount.getClearHistory,
    method: 'get',
    params
  })
}

export function rollbackBillPayments(data) {
  return request({
    url: URL.act.actualAmount.rollbackBillPayments,
    method: 'put',
    data
  })
}
// 水单-删除
export function deleteActualAmountFunc(data) {
  return request({
    url: URL.act.actualAmount.deleteActualAmountUrl,
    method: 'post',
    data
  })
}

export function updateActualReleaseStateFunc(actUuids, state) {
  return request({
    url: URL.act.actualAmount.updateActualReleaseStateUrl,
    method: 'post',
    data: actUuids,
    params: { state }
  })
}
export function checkPreActCreateVoucherFunc(params) {
  return request({
    url: URL.act.actualAmount.checkPreActCreateVoucherUrl,
    method: 'get',
    params
  })
}

// 检查实收付中是否有特殊费用
export function checkSpecialCharge(data) {
  return request({
    url: URL.act.actualAmount.checkSpecialChargeUrl,
    method: 'post',
    data
  })
}

// 检查是否生成过财务凭证
export function checkActualGenerateAccountingDocument(data) {
  return request({
    url: URL.act.actualAmount.checkActualGenerateAccountingDocumentUrl,
    method: 'post',
    data
  })
}
export function cancelClearHistory(data) {
  return request({
    url: URL.act.actualAmount.cancelClearHistory,
    method: 'post',
    data
  })
}
export function batchWriteOffFunc(data) {
  return request({
    url: URL.act.actualAmount.batchWriteOffUrl,
    method: 'post',
    data
  })
}

export function autoChargeWriteOffFunc(params) {
  return request({
    url: URL.act.actualAmount.autoChargeWriteOffUrl,
    method: 'post',
    params: params
  })
}

export function chargeWriteoffByMultiple(requestBody) {
  return request({
    url: URL.act.actualAmount.chargeWriteoffByMultipleRecordUrl,
    method: 'post',
    data: requestBody
  })
}

// generateSeqNoByKartenNumberRule
export function generateSeqNoByKartenNumberRule(body) {
  const data = new FormData()
  for (const key in body) {
    data.append(key, body[key])
  }
  return request({
    url: URL.act.actualAmount.generateSeqNoByKartenNumberRule,
    method: 'post',
    data
  })
}
// generateSeqNoByWriteOffRemarkNo
export function generateSeqNoByWriteOffRemarkNo(body) {
  const data = new FormData()
  for (const key in body) {
    data.append(key, body[key])
  }
  return request({
    url: URL.act.actualAmount.generateSeqNoByWriteOffRemarkNo,
    method: 'post',
    data
  })
}

export function revocationWriteOffHistoryFunc(data) {
  return request({
    url: URL.act.actualAmount.revocationWriteOffHistoryUrl,
    method: 'post',
    data
  })
}

// 集翊达：用友U8 CLOUD接口对接
export function checkActualAmountToYYU8(keys) {
  return request({
    url: URL.act.actualAmount.checkActualAmountToYYU8,
    method: 'post',
    data: keys
  })
}

// 集翊达：用友U8 CLOUD接口对接
export function syncActualAmountToYYU8(data) {
  return request({
    url: URL.act.actualAmount.syncActualAmountToYYU8,
    method: 'post',
    data
  })
}

// 青旅同步
export function syncCloudPlatformQL(data) {
  return request({
    url: URL.act.actualAmount.syncCloudPlatformQL,
    method: 'post',
    data
  })
}

// 预收款退回
export function returnApply(data) {
  return request({
    url: URL.act.actualAmount.returnApplyUrl,
    method: 'post',
    data
  })
}

// 预收款退回：状态更新
export function updateReturnApply(data) {
  return request({
    url: URL.act.actualAmount.updateReturnApplyUrl,
    method: 'post',
    data
  })
}

// 付款申请自动核销
export function autoBillPaymentWriteOffFunc(data) {
  return request({
    url: URL.act.actualAmount.autoBillPaymentWriteOffUrl,
    method: 'post',
    data
  })
}

// 修改核销匹配状态
export function modifyWriteoffMatchStatus(data) {
  return request({
    url: URL.act.actualAmount.modifyWriteoffMatchStatusUrl,
    method: 'put',
    data
  })
}
